module.exports = __webpack_public_path__ + "img/geo-background.784aac59.png";